import { Box, Grid, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const ModalPending = ({ openModalPending, pending, handleClosePending }) => {

    return (
        <Modal
            open={openModalPending}
            onClose={handleClosePending}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Grid container spacing={1}>
                    <TableContainer style={{ height: '550px', overflowY: 'auto' }}>
                        <Table>
                            <TableHead >
                                <TableRow>
                                    <TableCell>Referencia</TableCell>
                                    <TableCell>Crudo (MTS)</TableCell>
                                    <TableCell>Enrollado B/N (MTS)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pending.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{item?.product}</TableCell>
                                        <TableCell>{item?.crude_quantity}</TableCell>
                                        <TableCell>{item?.rolled_quantity}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Box>
        </Modal>
    )
}

export default ModalPending;
